import { CardContent, TableBody, TableCell, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { useEffect } from "react";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { _get, _post } from "../../../Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";

export default function OrderAccounts(props) {
  const merchant = props.merchant;
  const [orderUsers, setOrderUsers] = React.useState(null);
  const [oldOrderUsers, setOldOrderUsers] = React.useState(null);
  const merchantId = merchant.id;
  const setAddAccountDialogType = props.setAddAccountType;
  const setRemoveAccountDialogType = props.setRemoveAccountType;
  const setSelectedAccount = props.setSelectedAccount;

  function gatherOrderUsers(users) {
    const map = new Map();
    users.forEach((user) => {
      map.set(user.email, {
        email: user.email,
        orderUserId: user.id,
        app_version: user.app_version,
        poll_timeout_seconds: user.poll_timeout_seconds,
        open_url: user.open_url,
      });
    });
    return map;
  }

  useEffect(() => {
    function getOrderUsers() {
      _get("/nova/merchant/" + merchantId + "/mynbonnenuser")
        .then((response) => {
          setOrderUsers(gatherOrderUsers(response.data));
          setOldOrderUsers(gatherOrderUsers(response.data));
        })
        .catch((e) => {
          console.log(e);
        });
    }

    if (merchant && !orderUsers) {
      getOrderUsers();
    }
  }, [merchant, orderUsers, merchantId]);

  function updateOrderState(response) {
    if (response.data) {
      const user = response.data;
      orderUsers.set(user.email, {
        email: user.email,
        orderUserId: user.id,
        poll_timeout_seconds: user.poll_timeout_seconds,
        app_version: user.app_version,
        open_url: user.open_url,
      });
      oldOrderUsers.set(user.email, {
        email: user.email,
        orderUserId: user.id,
        poll_timeout_seconds: user.poll_timeout_seconds,
        app_version: user.app_version,
        open_url: user.open_url,
      });
    } else {
      const user = response;
      orderUsers.set(user.email, {
        email: user.email,
        orderUserId: user.orderUserId,
        poll_timeout_seconds: user.poll_timeout_seconds,
        app_version: user.app_version,
        open_url: user.open_url,
      });
    }
    const map = new Map();
    orderUsers.forEach((orderUser, email) => {
      map.set(email, orderUser);
    });
    setOrderUsers(map);
  }

  function changeText(event, orderUserId, type) {
    const text = event.target.value;
    if (!!text === false && type === "app_version") {
      toast.error(type + " must be a number larger than zero.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (!!text === false && type !== "open_url") {
      toast.error(type + " was not changed.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/mynbonnenuser/" + orderUserId, {
      [type]: event.target.value,
    })
      .then((response) => {
        toast.success(type + " changed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        updateOrderState(response);
      })
      .catch((e) => {
        toast.error(type + " could not be changed.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      });
  }

  function removeUser(handheldUser) {
    setSelectedAccount(handheldUser);
    setRemoveAccountDialogType("order");
  }

  if (!orderUsers) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid container direction={"column"}>
      <Grid container direction={"row"}>
        <Grid item lg={6}>
          <Typography variant={"h4"}>Order</Typography>
        </Grid>
        <Grid item lg={6}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setAddAccountDialogType("order")}
          >
            Account
          </Button>
        </Grid>
      </Grid>
      <Divider style={{ marginBottom: "20px" }} />
      <Grid container direction="column" spacing={4}>
        {[...orderUsers.keys()].map((email) => {
          return (
            <Grid item key={email}>
              <Card>
                <CardContent>
                  <Table>
                    <TableBody>
                      <TableRow style={{ display: "flex", flexDirection: "row" }}>
                        <TableCell>
                          <Typography style={{ margin: "1em" }} variant={"h5"}>
                            {email}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ display: "flex", flexDirection: "row" }}>
                        <TableCell>
                          <Paper
                            style={{
                              marginBottom: "1em",
                              padding: "1em",
                            }}
                            variant="outlined"
                          >
                            <TextField
                              label="Polling timeout in seconds"
                              type={"number"}
                              value={orderUsers.get(email).poll_timeout_seconds}
                              onChange={(event) => {
                                updateOrderState({
                                  email: email,
                                  orderUserId: orderUsers.get(email).orderUserId,
                                  app_version: orderUsers.get(email).app_version,
                                  open_url: orderUsers.get(email).open_url,
                                  poll_timeout_seconds: parseInt(event.target.value),
                                });
                              }}
                              onBlur={(event) => {
                                if (
                                  oldOrderUsers.get(email).poll_timeout_seconds !==
                                  orderUsers.get(email).poll_timeout_seconds
                                ) {
                                  changeText(event, orderUsers.get(email).orderUserId, "poll_timeout_seconds");
                                }
                              }}
                            />
                          </Paper>
                          <Paper
                            style={{
                              marginBottom: "1em",
                              padding: "1em",
                            }}
                            variant="outlined"
                          >
                            <TextField
                              label="App version"
                              type={"number"}
                              value={orderUsers.get(email).app_version}
                              onChange={(event) => {
                                updateOrderState({
                                  email: email,
                                  orderUserId: orderUsers.get(email).orderUserId,
                                  app_version: parseInt(event.target.value),
                                  poll_timeout_seconds: orderUsers.get(email).poll_timeout_seconds,
                                  open_url: orderUsers.get(email).open_url,
                                });
                              }}
                              onBlur={(event) => {
                                if (oldOrderUsers.get(email).app_version !== orderUsers.get(email).app_version) {
                                  changeText(event, orderUsers.get(email).orderUserId, "app_version");
                                }
                              }}
                            />
                          </Paper>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ display: "flex", flexDirection: "row" }}>
                          <Paper
                            style={{
                              marginBottom: "1em",
                              padding: "1em",
                            }}
                            variant="outlined"
                          >
                            <TextField
                              label="open url"
                              type={"text"}
                              value={orderUsers.get(email).open_url == null ? "" : orderUsers.get(email).open_url}
                              onChange={(event) => {
                                updateOrderState({
                                  email: email,
                                  orderUserId: orderUsers.get(email).orderUserId,
                                  app_version: orderUsers.get(email).app_version,
                                  poll_timeout_seconds: orderUsers.get(email).poll_timeout_seconds,
                                  open_url: event.target.value,
                                });
                              }}
                              onBlur={(event) => {
                                if (oldOrderUsers.get(email).open_url !== orderUsers.get(email).open_url) {
                                  changeText(event, orderUsers.get(email).orderUserId, "open_url");
                                }
                              }}
                            />
                          </Paper>
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ display: "flex", flexDirection: "row" }}>
                        <TableCell>
                          <Paper style={{ padding: "1em" }} variant="outlined">
                            <TextField
                              label="password"
                              type={"text"}
                              onBlur={(event) => changeText(event, orderUsers.get(email).orderUserId, "password")}
                            />
                          </Paper>
                          <Button
                            style={{ margin: "1em" }}
                            startIcon={<DeleteIcon />}
                            onClick={() => removeUser(orderUsers.get(email))}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}
